import { render } from "./error.vue?vue&type=template&id=20af9744"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20af9744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20af9744', __exports__)) {
    api.reload('20af9744', __exports__)
  }
  
  module.hot.accept("./error.vue?vue&type=template&id=20af9744", () => {
    api.rerender('20af9744', render)
  })

}


export default __exports__